import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
export default defineComponent(Analytics);
function Analytics() {
    this.defaultAttrs({ _99aq: null });
    this.after('initialize', function() {
        this.on(document, 'dataPushAnalytics', this.pushAnalytics);
    });
    this.pushAnalytics = function(e, data) {
        if (this.attr._99aq) {
            this.attr._99aq.push(data.data);
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/data/analytics.js